import { render, staticRenderFns } from "./popup-fk.vue?vue&type=template&id=b97e410e&scoped=true"
import script from "./popup-fk.vue?vue&type=script&lang=js"
export * from "./popup-fk.vue?vue&type=script&lang=js"
import style0 from "./popup-fk.vue?vue&type=style&index=0&id=b97e410e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97e410e",
  null
  
)

export default component.exports